import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const Be_pending = () => {
  const [bePendingList, setBePendingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  // ------------------------------
  // Alert Helper
  // ------------------------------
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    try {
      const response = await post("/all_jobs/be_pending");
      if (response.status === 200) {
        setBePendingList(response.data);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    }
  }, [showAlert]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", label_condition: "s_no", enableColumnFilter: false, enableSorting: false },
      { header: "Job Ref", accessorKey: "job_no" },
      { header: "Consignee", accessorKey: "consignees_name" },
      { header: "CFS Name", accessorKey: "cfs_name" },
      { header: "Liner", accessorKey: "liner_name" },
      { header: "BL No.", accessorKey: "bl_number"},
      { header: "Ctrs", accessorKey: "no_of_containers" },
      { header: "20FT", accessorKey: "count_20ft" },
      { header: "40FT", accessorKey: "count_40ft" },
      { header: "Arrived", accessorKey: "ts_arrival" },
      { header: "Wt (MT)", accessorKey: "gross_weight" },
      { header: "Dem Upto", accessorKey: "dem_upto" }
      
    ],
    []
  );
  // ------------------------------
  // Render
  // ------------------------------
  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">BE Pending</div>
          <div className="page-header-sub">{bePendingList.length} shipments awaiting Bill of Entry filing</div>
        </div>
      </div>

      <div className="card basic-data-table mt-3">
        <div className="card-header">
          <h5 className="card-title mb-0">BE Pending</h5>
        </div>
        <div className="card-body">
          <Customtable
            table_title="BE Pending"
            columns={columns}
            data={bePendingList}
            isGlobalFilter={true}
            isPagination={true}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isExportButton={true}
          />
        </div>
      </div>
    </>
  );
};

export default Be_pending;